/* import __COLOCATED_TEMPLATE__ from './react-bridge-with-providers.hbs'; */
import { service } from '@ember/service';

import ReactBridge from '@qonto/react-migration-toolkit/components/react-bridge';

import { CustomProviders } from '../react/react-bridge/custom-providers';

export default class ReactBridgeWithProviders extends ReactBridge {
  @service launchdarkly;

  customProvidersComponent = CustomProviders;

  get customProvidersProps() {
    return {
      ldFlags: this.launchdarkly?.allFlags || {},
    };
  }
}
